export default "/SiteCollectionImages/react-apps/nykredit/src/images/checkbox.png";